export const localizeKey = (key, lang) => {
  const mappings = {
    'edit': {
      'en': 'Edit',
      'ru': 'Редактировать'
    },
    'delete': {
      'en': 'Delete',
      'ru': 'Удалить'
    },
    'editMessage': {
      'en': 'Edit message',
      'ru': 'Редактировать сообщение'
    },
    'edited': {
      'en': 'edited',
      'ru': 'отредактировано'
    },
    'deleteMessage': {
      'en': 'Delete message',
      'ru': 'Удалить сообщение'
    },
    'deletedBySender': {
      'en': 'Message deleted by sender',
      'ru': 'Сообщение удалено отправителем'
    },
    'save': {
      'en': 'Save',
      'ru': 'Сохранить'
    },
    'cancel': {
      'en': 'Cancel',
      'ru': 'Отмена'
    },
    'confirmDeleteMessage': {
      'en': 'Are you sure you want to delete this message?',
      'ru': 'Вы уверены, что хотите удалить это сообщение?'
    },
    'homePage': {
      'en': 'Home page',
      'ru': 'Главная страница'
    },
    'orSearchForBooksHere': {
      'en': 'Or, search for books here:',
      'ru': 'Или можете поискать книгу здесь (на русском и английском):'
    },
    'backToMyPage': {
      'en': '⬅️ Back to users',
      'ru': '⬅️ Назад к пользователям'
    },
    'putArtIntoCategories': {
      'en': 'Put art into one of the categories',
      'ru': 'Добавьте произведение в одну из категорий'
    },
    'artIsEitherMovieGameBook': {
      'en': 'Art is either movie, videogame or book',
      'ru': 'Произведение может быть фильмом, игрой или книгой'
    },
    'copyLinkFromPlatforms': {
      'en': 'Copy a link from one of the platforms',
      'ru': 'Скопируйте ссылку с одной из платформ'
    },
    'wikiMustHaveEnglishVersion': {
      'en': 'for books, provide books.apple.com link to a book, or use search inside the app',
      'ru': 'для добавления книги введите ссылку на на books.apple.com или используйте поиск внутри приложения'
    },
    'othersReaction': {
      'en': 'added to their library too',
      'ru': 'также добавили в свою библиотеку'
    },
    'myReaction': {
      'en': 'Add to mine',
      'ru': 'Добавить к себе'
    },
    'addedToTheirLib': {
      'en': 'added to library',
      'ru': 'добавил(а) в библиотеку'
    },
    'removeFromLib': {
      'en': 'Remove',
      'ru': 'Удалить'
    },
    'like_did': {
      'en': 'liked',
      'ru': 'лайкнул(а)'
    },
    'todo_did': {
      'en': 'added to todo',
      'ru': 'запланировал(а)'
    },
    'finished_did': {
      'en': 'finished',
      'ru': 'ознакомился(ась)'
    },
    'chooseCategory': {
      'en': 'Choose category',
      'ru': 'Выберите категорию'
    },
    'collapsibleHideCap': {
      'en': 'Hide',
      'ru': 'Скрыть'
    },
    'collapsibleShowCap': {
      'en': 'Show',
      'ru': 'Показать'
    },
    'myLikes': {
      'en': "My likes",
      'ru': "Мне понравилось"
    },
    'likes': {
      'en': "Favorites",
      'ru': "Любимое"
    },
    'todos': {
      'en': "Todos",
      'ru': "Планы"
    },
    'finisheds': {
      'en': "Checked out",
      'ru': "Ознакомлен(а)"
    },
    'publicTodos': {
      'en': "Public todos",
      'ru': "Опубликованные планы"
    },
    'like': {
      'en': "Like",
      'ru': "Понравилось"
    },
    'links': {
      'en': "Links",
      'ru': "Ссылки"
    },
    'liked': {
      'en': "liked",
      'ru': "оценил"
    },
    'something': {
      'en': "something",
      'ru': "что-то"
    },
    'recommendedToYou': {
      'en': "recommended to you",
      'ru': "рекомендовал вам"
    },
    'planned': {
      'en': "planned",
      'ru': "запланировал(а)"
    },
    'home': {
      'en': "Liked",
      'ru': "Понравилось"
    },
    'myTodos': {
      'en': "My todos",
      'ru': "Оценю позже"
    },
    'click_cap': {
      'en': "Click",
      'ru': "Нажми"
    },
    'toGetNotifications': {
      'en': "to get notifications",
      'ru': ", чтобы получать нотификации"
    },
    'copySecretToken_cap': {
      'en': "Copy secret token",
      'ru': "Скопируйте секретный токен"
    },
    'sendIt_cap': {
      'en': "Send it",
      'ru': "Отправьте его"
    },
    'here_direction': {
      'en': "here",
      'ru': "сюда"
    },
    'setUserName': {
      'en': "Set user name",
      'ru': "Поменять юзернейм"
    },
    'recommendedByMe': {
      'en': "By me",
      'ru': "От меня"
    },
    'recommendedToMe': {
      'en': "To me",
      'ru': "Мне"
    },
    'toWhomRecommended': {
      'en': "To whom",
      'ru': "Кому"
    },
    'byWhomRecommended': {
      'en': "By whom",
      'ru': "От кого"
    },
    'users': {
      'en': "Users",
      'ru': "Пользователи"
    },
    'addToMyList': {
      'en': "In my library",
      'ru': "В моей библиотеке"
    },
    'addTodo': {
      'en': "Add todo",
      'ru': 'Оценю позже'
    },
    'addFinished': {
      'en': "Checked out",
      'ru': "Ознакомился"
    },
    'settings': {
      'en': "Settings",
      'ru': "Настройки"
    },
    'enterWikiLink': {
      'en': "Wiki link",
      'ru': "Ссылка на вики"
    },
    'wikiLink': {
      'en': "Wikipedia link",
      'ru': "Ссылка на вики"
    },
    'likeTime': {
      'en': "Time of like",
      'ru': "Дата добавления"
    },
    'todoTime': {
      'en': "Time of todo",
      'ru': "Дата добавления"
    },
    'recommendationTime': {
      'en': "Recommendation time",
      'ru': "Дата добавления"
    },
    'recommend': {
      'en': "Recommend personally",
      'ru': "Рекомендовать персонально"
    },
    // 'personalRecommendations': {
    //   'en': "Personal recommendations",
    //   'ru': "Персональные рекомендации"
    // },
    'pinsLimitReached': {
      'en': "Pins limit reached (max 5)",
      'ru': "Максимум 5 закрепленных"
    },
    'fromUser': {
      'en': "From user",
      'ru': "От кого"
    },
    'toUser': {
      'en': "To user",
      'ru': "Кому"
    },    
    'wikiLinkHint': {
      'en': "Link to a movie, a game or a book",
      'ru': "Ссылка на фильм, игру или книгу"
    },
    'likesHeader': {
      'en': "Share what you liked. Other people will see it.",
      'ru': "Поделитесь тем, что вам понравилось. Другие люди увидят это."
    },
    'recommendedToMeHeader': {
      'en': "What other people recommended to you privately.",
      'ru': "То, что рекомендовали лично вам."
    },
    'recommendedByMeHeader': {
      'en': "What you recommended to people privately.",
      'ru': "То, что вы рекомендовали лично."
    },
    'recommendationPostSuccess': {
      'en': 'Successfully posted recommendation',
      'ru': 'Рекомендация успешно отправлена'
    },
    'timeOf': {
      'en': 'Time of',
      'ru': 'Время'
    },
    'of_like': {
      'en': 'like',
      'ru': 'лайка'
    },
    'of_recommendation': {
      'en': 'recommendation',
      'ru': 'рекомендации'
    },
    'of_todo': {
      'en': 'todo',
      'ru': 'добавления в планы'
    },
    'of_finished': {
      'en': 'check out',
      'ru': 'ознакомления'
    },
    'finishedNavBar': {
      'en': "Checked out",
      'ru': "Ознакомился(лась)"
    },
    'finished': {
      'en': "checked out",
      'ru': "ознакомился(лась)"
    },
    'share': {
      'en': 'Share',
      'ru': 'Поделиться'
    },
    'copy': {
      'en': 'Copy',
      'ru': 'Скопировать'
    },
    'copyLink': {
      'en': 'Copy link',
      'ru': 'Скопировать ссылку'
    },
    'messagedIn': {
      'en': "messaged in",
      'ru': "написал(а) в"
    },
    'chat': {
      'en': 'chat',
      'ru': 'чат'
    },
    'privateChat': {
      'en': 'private chat',
      'ru': 'приватный чат'
    },
    'messages': {
      'en': 'messages',
      'ru': 'сообщений'
    },
    'chat_in': {
      'en': "a chat",
      'ru': "чате"
    },
    'shareEvent': {
      'en': "Share event",
      'ru': "Поделиться событием"
    },
    'publishMyPlan': {
      'en': "Publish my plan",
      'ru': "Опубликовать план"
    },
    'unpublishMyPlan': {
      'en': "Unpublish my plan",
      'ru': "Убрать из опубликованных планов"
    },
    'shareRecomText': {
      'en': 'Here\'s recommendedation for you',
      'ru': 'Лови рекомендацию'
    },
    'shareRecomNotMiss': {
      'en': 'Share manually with your friend so they don\'t miss it',
      'ru': 'Поделитесь вручную этой рекомендацией, чтобы ее не пропустили'
    },
    'recommendationForYou': {
      'en': 'Here\'s recommendedation for you',
      'ru': 'Рекомендация для вас'
    },
    'copiedToClipboard_lower': {
      'en': 'copied to clipboard',
      'ru': 'скопировано'
    },
    'eventOwner': {
      'en': "Event owner",
      'ru': "Автор события"
    },
    'subscribeToChat': {
      'en': "Subscribe to chat notifications",
      'ru': "Подписаться на уведомления из чата"
    },
    'unsubscribeFromChat': {
      'en': "Unsubscribe from chat notifications",
      'ru': "Отписаться от уведомлений из чата"
    },
    'uploadAvatar': {
      'en': "Upload avatar",
      'ru': "Загрузить аватар"
    },
    'typeYourMessageHere': {
      'en': "Type your message here...",
      'ru': "Написать сообщение..."
    },
    'youHaveUnreadMessagesInChat': {
      'en': "You have unread messages in chat",
      'ru': "У вас есть непрочитанные сообщения в чате"
    },
    'follow': {
      'en': "Follow",
      'ru': "Подписаться"
    },
    'requested': {
      'en': "Requested",
      'ru': "Запрошено"
    },
    'approved': {
      'en': "Following",
      'ru': "Подписаны"
    },
    'unfollow': {
      'en': "Unfollow",
      'ru': "Отписаться"
    },
    // Add more mappings as needed
  };

  return mappings[key][lang];
}

const GENRE_EN_TO_RU = {
  'action': 'боевик',
  'action-adventure': 'приключенческий боевик',
  'adventure': 'приключения',
  'animation': 'анимация',
  'anime': 'аниме',
  'biography': 'биография',
  'cartoon': 'мультфильм',
  'comedy': 'комедия',
  'crime': 'криминал',
  'detective': 'детектив',
  'documentary': 'документальный',
  'drama': 'драма',
  'family': 'семейный',
  'fantasy': 'фэнтези',
  'film-noir': 'нуар',
  'noir': 'нуар',
  'history': 'история',
  'historical': 'историческое',
  'horror': 'хоррор',
  'music': 'музыка',
  'musical': 'мюзикл',
  'mystery': 'мистика',
  'news': 'новости',
  'reality-tv': 'реалити-шоу',
  'reality tv': 'реалити-шоу',
  'romance': 'мелодрама',
  'sci-fi': 'фантастика',
  'science fiction': 'фантастика',
  'short': 'короткометражка',
  'sport': 'спорт',
  'sports': 'спорт',
  'talk-show': 'ток-шоу',
  'talk show': 'ток-шоу',
  'thriller': 'триллер',
  'war': 'военный',
  'western': 'вестерн',
  'tv movie': 'тв-фильм',
  'tv-movie': 'тв-фильм',
  // Video games
  'rpg': 'рпг',
  'role-playing': 'ролевая игра',
  'role-playing game': 'ролевая игра',
  'strategy': 'стратегия',
  'simulation': 'симулятор',
  'simulator': 'симулятор',
  'racing': 'гонки',
  'puzzle': 'головоломка',
  'platformer': 'платформер',
  'platform': 'платформер',
  'shooter': 'шутер',
  'first-person shooter': 'шутер от первого лица',
  'fps': 'шутер от первого лица',
  'third-person shooter': 'шутер от третьего лица',
  'fighting': 'файтинг',
  'survival': 'выживание',
  'survival horror': 'хоррор-выживание',
  'stealth': 'стелс',
  'indie': 'инди',
  'mmo': 'ммо',
  'mmorpg': 'ммо-рпг',
  'sandbox': 'песочница',
  'open world': 'открытый мир',
  'roguelike': 'рогалик',
  'roguelite': 'роглайт',
  'visual novel': 'визуальная новелла',
  'metroidvania': 'метроидвания',
  'beat \'em up': 'битэмап',
  'beat em up': 'битэмап',
  'hack and slash': 'слэшер',
  'tower defense': 'тауэр-дефенс',
  'card game': 'карточная игра',
  'board game': 'настольная игра',
  'rhythm': 'ритм-игра',
  'party': 'пати-игра',
  'arcade': 'аркада',
  'point-and-click': 'квест',
  'point and click': 'квест',
  'mmorts': 'ммо-стратегия',
  'rts': 'стратегия в реальном времени',
  'turn-based strategy': 'пошаговая стратегия',
  // Books
  'fiction': 'художественная литература',
  'non-fiction': 'нон-фикшн',
  'nonfiction': 'нон-фикшн',
  'memoir': 'мемуары',
  'self-help': 'саморазвитие',
  'poetry': 'поэзия',
  'young adult': 'подростковая литература',
  "children's": 'детская литература',
  'children': 'детская литература',
  'classic': 'классика',
  'classics': 'классика',
  'philosophy': 'философия',
  'travel': 'путешествия',
  'cooking': 'кулинария',
  'religion': 'религия',
  'science': 'наука',
  'comics': 'комиксы',
  'graphic novel': 'графический роман',
  'historical fiction': 'историческая литература',
  'short story': 'рассказ',
  'short stories': 'рассказы',
  'essay': 'эссе',
  'essays': 'эссе',
  'manga': 'манга',
  'light novel': 'ранобэ',
  'business': 'бизнес',
  'economics': 'экономика',
  'psychology': 'психология',
  'health': 'здоровье',
};

const GENRE_RU_TO_EN = (() => {
  const m = {};
  for (const [en, ru] of Object.entries(GENRE_EN_TO_RU)) {
    if (!m[ru]) m[ru] = en;
  }
  return m;
})();

const capitalizeFirst = (s) => {
  if (!s) return s;
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const localizeGenre = (genre, lang) => {
  if (genre === null || genre === undefined) return '';
  const trimmed = String(genre).trim();
  if (!trimmed) return '';
  const key = trimmed.toLowerCase();
  let result = trimmed;
  if (lang === 'ru') {
    if (GENRE_EN_TO_RU[key]) result = GENRE_EN_TO_RU[key];
  } else {
    if (GENRE_RU_TO_EN[key]) result = GENRE_RU_TO_EN[key];
  }
  return capitalizeFirst(result);
};

export const localizeGenres = (genres, lang) => (genres || []).map((g) => localizeGenre(g, lang));

export const localizeArt = (art, lang) => {
  if (lang === 'ru') {
    return {
      'name': art.ruName !== '' ? art.ruName : art.name,
      'description': art.ruDescription !== '' ? art.ruDescription : art.description,
      'wikiLink': art.ruWikiArticleLink !== '' ? decodeURIComponent(art.ruWikiArticleLink) : art.wikiArticleLink,
      'videoGameDeveloper': art.ruVideoGameDeveloper ? art.ruVideoGameDeveloper : art.videoGameDeveloper,
      'genres': localizeGenres(art.ruGenres ? art.ruGenres : art.genres, lang),
      'country': art.ruCountry ? art.ruCountry : art.country,
      'actors': art.ruActors ? art.ruActors : art.actors,
      'duration': art.duration
    }
  }

  return {
    'name': art.name,
    'description': art.description,
    'wikiLink': art.wikiArticleLink,
    'videoGameDeveloper': art.videoGameDeveloper,
    'genres': localizeGenres(art.genres, lang),
    'country': art.country,
    'actors': art.actors,
    'duration': art.duration
  }
}